import FavoritItem from './FavoritItem';

export default FavoritItem;
